import _sfc_main from "./component-library132.mjs";
import "./component-library133.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "card-group" }, _vm._l(_setup.itemsWithType, function(item, index) {
    return _c(_setup.Card, _vm._b({ key: index, class: `card-group__tile card-group__tile--${item.typeComponent}`, scopedSlots: _vm._u([{ key: "background", fn: function() {
      return [_vm._t("background", null, { "item": item })];
    }, proxy: true }, { key: "image", fn: function() {
      return [_vm._t("image", null, { "item": item })];
    }, proxy: true }, { key: "imageBadge", fn: function() {
      return [_vm._t("imageBadge", null, { "item": item })];
    }, proxy: true }, { key: "label", fn: function() {
      return [_vm._t("label", null, { "item": item })];
    }, proxy: true }, { key: "heading", fn: function() {
      return [_vm._t("heading", null, { "item": item })];
    }, proxy: true }, { key: "subtitle", fn: function() {
      return [_vm._t("subtitle", null, { "item": item })];
    }, proxy: true }, { key: "default", fn: function() {
      return [_vm._t("default", null, { "item": item })];
    }, proxy: true }, { key: "action", fn: function() {
      return [_vm._t("action", null, { "item": item })];
    }, proxy: true }], null, true) }, "Card", item.card, false));
  }), 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "46030048",
  null,
  null
);
const cardGroup = __component__.exports;
export {
  cardGroup as default
};
